export {OneToTwoCSBPReportWithRecordPopover as OneToTwoCSBPReport} from './OneToTwoCSBPReport';
